export const BOOKS = [
  {
    id: 1,
    image: 'https://m.media-amazon.com/images/I/71AxeLOhKTL._SY522_.jpg',
    title: `Dad Jokes: Over 600 of the Best (Worst) Jokes Around and Perfect Christmas Gag Gift for All Ages! (World's Best Dad Jokes Collection)`,
    author: 'Jimmy Niro',
    description:
      'A USA Today bestseller! Dad Jokes: the good, the bad, and the terrible―the perfect funny Christmas gift for dads and pun-lovers alike!',
  },
  {
    id: 2,
    image: 'https://m.media-amazon.com/images/I/81OkWjcf4WL._SY522_.jpg',
    title: 'The Nightingale: A Novel',
    author: 'Kristin Hannah',
    description:
      'A #1 New York Times bestseller, Wall Street Journal Best Book of the Year, and soon to be a major motion picture, this unforgettable novel of love and strength in the face of war has enthralled a generation.',
  },
  {
    id: 3,
    image: 'https://m.media-amazon.com/images/I/81kTEpq8k+L._SY522_.jpg',
    title: `Things I Can't Say Out Loud In Meetings: Funny Notebook for Work, Gag Gift, Boss, Office, Secret Santa Gift for Coworker (Lined Journal with Quotes)`,
    author: 'Taylor A. Wilde',
    description: `A Fun Office Notebook: Perfect for Gifting to Coworkers, Colleagues, Employees, or your Boss! This journal features a humorous cover, lined journal pages with snarky/sarcastic quotes on alternate pages, and also a “This Book Belongs To” page which you can personalize if you're giving as a gift.`,
  },
]
